import ability from './ability'

export const canNavigate = route => (route.meta.resource ? ability.can(route.meta.action || 'read', route.meta.resource) : true)

export const _ = undefined
